<div>

  <mat-tab-group>

    <mat-tab label="Text Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>

</div>
